import AuthContext from 'contexts/AWSCognitoContext';
import { useContext } from 'react';
import type { ContactKind, RequiredFieldForm } from 'types/back-office-settings';

/** `useRequiredFields`' readers over a session's `requiredFields`, for code that is handed the list. */
export const requiredFieldReaders = (requiredFields: string[] | null | undefined) => ({
    /** Whether the field must be filled; a Client form field only for a known contact kind. */
    isRequired: (form: RequiredFieldForm, field: string, kind?: ContactKind) =>
        form === 'CLIENT'
            ? !!kind && !!requiredFields?.includes(`${form}:${field}:${kind}`)
            : !!requiredFields?.includes(`${form}:${field}`),
    /** The VAT number row's tick: a company in the firm's own country need not give a VAT number. */
    vatOptionalInOwnCountry: !!requiredFields?.includes('CLIENT:VAT_OPTIONAL_IN_OWN_COUNTRY'),
});

/**
 * Which fields the signed-in colleague must fill to save a contact, case or timecard. The session carries the
 * answer as `requiredFields` (`FORM:FIELD`, `FORM:FIELD:KIND` on the Client form), with each field's audience already
 * applied by the backend. Reads the auth context directly, as `useSettings` does.
 */
export const useRequiredFields = () => requiredFieldReaders(useContext(AuthContext)?.user?.requiredFields);
